var _a;
const u = up.util;
up.Change.FromContent = (_a = class FromContent extends up.Change {
        constructor(options) {
            super(options);
            this._origin = options.origin;
            this._preflight = options.preflight;
            this._layers = up.layer.getAll(options);
        }
        _getPlans() {
            let plans = [];
            this._filterLayers();
            this._improveOptionsFromResponseDoc();
            this._expandIntoPlans(plans, this._layers, this.options.target);
            this._expandIntoPlans(plans, this._layers, this.options.fallback);
            return plans;
        }
        _isRenderableLayer(layer) {
            return (layer === 'new') || layer.isAlive();
        }
        _filterLayers() {
            this._layers = u.filter(this._layers, this._isRenderableLayer);
        }
        _expandIntoPlans(plans, layers, targets) {
            for (let layer of layers) {
                for (let target of this._expandTargets(targets, layer)) {
                    const props = { ...this.options, target, layer, defaultPlacement: this._defaultPlacement() };
                    const change = layer === 'new' ? new up.Change.OpenLayer(props) : new up.Change.UpdateLayer(props);
                    plans.push(change);
                }
            }
        }
        _expandTargets(targets, layer) {
            return up.fragment.expandTargets(targets, { layer, mode: this.options.mode, origin: this._origin });
        }
        execute() {
            if (this.options.preload) {
                return Promise.resolve();
            }
            return this._seekPlan(this._executePlan.bind(this)) || this._cannotMatchPostflightTarget();
        }
        _executePlan(matchedPlan) {
            return up.fragment.mutate(() => matchedPlan.execute(this._getResponseDoc(), this._onPlanApplicable.bind(this, matchedPlan)));
        }
        _isApplicablePlanError(error) {
            return !(error instanceof up.CannotMatch);
        }
        _onPlanApplicable(plan) {
            let primaryPlan = this._getPlans()[0];
            if (plan !== primaryPlan) {
                up.puts('up.render()', 'Could not match primary target "%s". Updating a fallback target "%s".', primaryPlan.target, plan.target);
            }
            let { assets } = this._getResponseDoc();
            if (assets) {
                up.script.assertAssetsOK(assets, plan.options);
            }
            this.options.handleAbort(this.getPreflightProps());
        }
        _getResponseDoc() {
            if (this._preflight)
                return;
            const docOptions = u.pick(this.options, [
                'target',
                'content',
                'fragment',
                'document',
                'html',
                'cspInfo',
                'origin',
                'data',
            ]);
            up.migrate.handleResponseDocOptions?.(docOptions);
            if (this._defaultPlacement() === 'content') {
                docOptions.target = this._firstExpandedTarget(docOptions.target);
            }
            return new up.ResponseDoc(docOptions);
        }
        _improveOptionsFromResponseDoc() {
            if (this._preflight)
                return;
            let responseDoc = this._getResponseDoc();
            if (this.options.fragment) {
                this.options.target ||= responseDoc.rootSelector();
            }
            this.options.title = up.history.refineOption(this.options.title, responseDoc.title);
            this.options.metaTags = up.history.refineOption(this.options.metaTags, responseDoc.metaTags);
            this.options.lang = up.history.refineOption(this.options.lang, responseDoc.lang);
        }
        _defaultPlacement() {
            if (!this.options.document && !this.options.fragment) {
                return 'content';
            }
        }
        _firstExpandedTarget(target) {
            let layer = this._layers[0] || up.layer.root;
            return this._expandTargets(target || ':main', layer)[0];
        }
        getPreflightProps(opts = {}) {
            const getPlanProps = (plan) => plan.getPreflightProps();
            return this._seekPlan(getPlanProps) || opts.optional || this._cannotMatchPreflightTarget();
        }
        _cannotMatchPreflightTarget() {
            this._cannotMatchTarget('Could not find target in current page');
        }
        _cannotMatchPostflightTarget() {
            this._cannotMatchTarget('Could not find common target in current page and response');
        }
        _cannotMatchTarget(reason) {
            if (this._getPlans().length) {
                const planTargets = u.uniq(u.map(this._getPlans(), 'target'));
                const humanizedLayerOption = up.layer.optionToString(this.options.layer);
                throw new up.CannotMatch([reason + " (tried selectors %o in %s)", planTargets, humanizedLayerOption]);
            }
            else if (this._layers.length === 0) {
                this._cannotMatchLayer();
            }
            else if (this.options.didForceFailOptions) {
                throw new up.CannotMatch('No target selector given for failed responses (https://unpoly.com/failed-responses)');
            }
            else {
                throw new up.CannotMatch('No target selector given');
            }
        }
        _cannotMatchLayer() {
            throw new up.CannotMatch('Could not find a layer to render in. You may have passed an unmatchable layer reference, or a detached element.');
        }
        _seekPlan(fn) {
            for (let plan of this._getPlans()) {
                try {
                    return fn(plan);
                }
                catch (error) {
                    if (this._isApplicablePlanError(error)) {
                        throw error;
                    }
                }
            }
        }
    },
    (() => {
        u.memoizeMethod(_a.prototype, {
            _getPlans: true,
            _getResponseDoc: true,
            getPreflightProps: true,
        });
    })(),
    _a);
